import React from 'react';

import { useTheme } from '@mui/material/styles';

import FileUploadIcon from '@mui/icons-material/FileUpload';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const UploadActionButton = (props: IBaseActionButtonProps) => {
  const theme = useTheme();
  const { classes } = useStyles(theme);

  return (
    <BaseActionButton {...props}>
      <FileUploadIcon />
    </BaseActionButton>
  );
};

export default UploadActionButton;
